export { default as useCustomerDetailModal } from './useCustomerDetailModal'
export { default as CustomerDetailModal } from './Modal'
export * from './type'
